import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FeedFollowBehavior } from '../../models';

export const useFeedFollowBehaviorFilter = () => {
  const { t } = useTranslation();

  const group = useMemo(
    () => ({
      id: 'feedFollowBehavior',
      title: t('common.feed-follow-behavior'),
      multiCheck: true,
      allowReset: true,
      items: Object.values(FeedFollowBehavior).map((value) => ({
        id: value,
        label: t(`feedFollowBehavior.${value}`),
        value,
      })),
    }),
    [t]
  );

  return { group };
};
